import * as React from "react";

import * as CustomLists from "../models/customLists";
import { PlaceholderImages } from "../assets/PlaceholderImages";
import Paper from "@material-ui/core/Paper";

import { strings } from "../core/localizedStrings";
import { Fonts } from "../core/utils/Fonts";

var Row = require("react-flexbox-grid").Row;
var Col = require("react-flexbox-grid").Col;

export interface CategoryTypeCardProps extends React.Props<any> {
    categoryType: CustomLists.CategoryType;
    onSelectedCallback: (type: CustomLists.CategoryType) => void;
    description?: string;
}

export default class CategoryTypeCard extends React.Component<CategoryTypeCardProps> {
    private imageURL: string;
    private secondImageURL: string;
    public render() {
        var text: string;
        switch (this.props.categoryType) {
            case CustomLists.CategoryType.Vocabulary:
                this.imageURL = PlaceholderImages.VOCABULARY;
                text = strings.imageWithText;
                break;

            case CustomLists.CategoryType.VocabularyTextOnly:
                this.imageURL = PlaceholderImages.VOCABULARY_TEXT_ONLY;
                text = strings.singleText;
                break;

            case CustomLists.CategoryType.Expression:
                this.imageURL = PlaceholderImages.EXPRESSION;
                text = strings.imageWithTwoText;
                break;

            case CustomLists.CategoryType.ExpressionTextOnly:
                this.imageURL = PlaceholderImages.EXPRESSION_TEXT_ONLY;
                text = strings.twoTextOnly;
                break;

            case CustomLists.CategoryType.Lesson:
                this.imageURL = PlaceholderImages.VOCABULARY;
                this.secondImageURL = PlaceholderImages.EXPRESSION;
                text = strings.lessonDescription;
                break;

            default:
                break;
        }

        if (this.props.description) {
            text = this.props.description;
        }

        let styles = { header: { fontFamily: Fonts.BalsamiqSans, fontSize: 18, padding: "20px 20px 20px 20px" } };

        return (
            <div style={{ width: "100%", paddingTop: 20 }}>
                <Paper
                    style={{ margin: 5, cursor: "pointer" }}
                    children={
                        <div onClick={this.onCardClicked}>
                            <Row middle="xs" center="xs">
                                <Col xs={12} sm={6} style={styles.header}>
                                    <Row center="xs">
                                        {this.secondImageURL ? (
                                            <Col>
                                                <Paper children={<img src={this.imageURL} style={{ height: 40 }} />} />
                                                <div style={{ paddingTop: 5 }} />
                                                <Paper
                                                    children={<img src={this.secondImageURL} style={{ height: 40 }} />}
                                                />
                                            </Col>
                                        ) : (
                                            <Paper children={<img src={this.imageURL} style={{ height: 80 }} />} />
                                        )}
                                    </Row>
                                </Col>
                                <Col xs={12} sm={6} style={styles.header}>
                                    <Row center="xs">
                                        <div>{text}</div>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    }
                />
            </div>
        );
    }

    private onCardClicked = (event: any) => {
        this.props.onSelectedCallback(this.props.categoryType);
    };
}
